'use es6';

import I18n from 'I18n';
import ImmutableModel from 'DesignData/models/ImmutableModel';

const i18nText = key => I18n.text(`designdata.models.keybindings.${key}`);

export default class Keybinding extends ImmutableModel {
  /**
   * @constructor
   * Pass in I18n key for shortcut/label/description to show in keybinding manual
   */
  constructor(props) {
    const {
      handler,
      i18nKey
    } = props;
    return super({
      handler,
      shortcut: i18nKey ? i18nText(`${i18nKey}.shortcut`) : '',
      label: i18nKey ? i18nText(`${i18nKey}.label`) : '',
      description: i18nKey ? i18nText(`${i18nKey}.description`) : ''
    });
  }

}